import * as React from 'react';
import {
    ApiKeys,
    Documents,
    DocumentTypes,
    ExportConfig,
    Integrations,
    Requests,
    Rules,
    RulesConfig,
    Suppliers,
    Tags,
    Plan,
    TemplateCollections,
    Templates,
    UserDocuments,
    UserHistory,
    UserProfile,
    Users,
} from '../routes';
import {
    resourceApiKey,
    resourceDocuments,
    resourceDocumentTypes,
    resourceExportConfig,
    resourceIntegrations,
    resourcePlan,
    resourceProfile,
    resourceRequests,
    resourceRuleConfig,
    resourceRules,
    resourceSuppliers,
    resourceTags,
    resourceTemplateCollections,
    resourceTemplates,
    resourceUserDocuments,
    resourceUserHistory,
    resourceUsers,
    roleAdmin,
    roleOperator,
    roleUser,
} from '../constants';

export interface RouterServiceItem {
    path: string;
    component: React.FunctionComponent<any> | React.ReactComponentElement<any>;
    allowedRoles?: Array<string>;
}

const routes: Array<RouterServiceItem> = [
    {
        path: resourceTags,
        component: Tags,
        allowedRoles: [roleUser],
    },
    {
        path: resourcePlan,
        component: Plan,
        allowedRoles: [roleUser],
    },
    {
        path: resourceDocuments,
        component: Documents,
    },
    {
        path: resourceUserDocuments,
        component: UserDocuments,
    },
    {
        path: resourceApiKey,
        component: ApiKeys,
        allowedRoles: [roleUser, roleAdmin],
    },
    {
        path: resourceProfile,
        component: UserProfile,
    },
    {
        path: resourceSuppliers,
        component: Suppliers,
    },
    {
        path: resourceRules,
        component: Rules,
        allowedRoles: [roleUser, roleAdmin],
    },
    {
        path: resourceIntegrations,
        component: Integrations,
        allowedRoles: [roleUser, roleAdmin],
    },
    {
        path: resourceExportConfig,
        component: ExportConfig,
        allowedRoles: [roleAdmin],
    },
    {
        path: resourceRuleConfig,
        component: RulesConfig,
        allowedRoles: [roleAdmin]
    },
    {
        path: resourceDocumentTypes,
        component: DocumentTypes,
        allowedRoles: [roleAdmin]
    },
    {
        path: resourceTemplates,
        component: Templates,
        allowedRoles: [roleOperator, roleAdmin],
    },
    {
        path: resourceUsers,
        component: Users,
        allowedRoles: [roleAdmin],
    },
    {
        path: resourceUserHistory,
        component: UserHistory,
        allowedRoles: [roleAdmin],
    },
    {
        path: resourceRequests,
        component: Requests,
        allowedRoles: [roleUser, roleOperator, roleAdmin],
    },
    {
        path: resourceTemplateCollections,
        component: TemplateCollections,
        allowedRoles: [roleOperator, roleAdmin],
    },
];

export default routes;
